<script setup>
import { computed } from 'vue'

const props = defineProps({
  color: { type: String, required: true },
  won: { type: Boolean, default: false },
  active: { type: Boolean, default: false },
  filterId: { type: String, required: true },
})

const FLAG_PATH =
  'm 0,0 c -19.342,0 -37.472,-6.5 -52.213,-20.018 l 1.222,-9.433 14.87,-128.416 1.098,-9.496 1.191,-8.12 c 16.257,14.337 33.507,19.59 51.337,19.589 48.899,-0.001 102.137,-39.515 151.059,-39.515 17.781,0 34.994,5.221 51.22,19.457 0.168,3.899 -0.33,7.356 -0.747,11.123 l -1.04,9.417 -0.936,8.578 -1.078,9.914 -0.978,9.01 -0.985,9.073 -1.025,9.427 -0.933,8.571 -1.079,9.919 -0.979,9.009 -1.03,9.489 -0.979,9.014 -0.93,8.57 -1.077,9.923 -0.929,8.578 -1.124,10.379 c -0.211,1.946 -0.415,3.865 -0.871,5.712 -15.708,-12.483 -29.591,-18.774 -49.243,-19.366 -1.054,-0.032 -2.05,-0.086 -3.047,-0.086 -0.514,0 -1.028,0.015 -1.55,0.054 l -8.982,0.675 C 121.019,-37.523 91.429,-25.933 72.876,-18.798 53.082,-11.186 33.28,-3.714 12.27,-0.848 8.14,-0.284 4.044,0 0,0'

const fill = computed(() => (props.won ? props.color : 'none'))
const strokeAttr = computed(() => (props.won ? 'none' : '#000'))
const strokeWidth = computed(() => (props.won ? 0 : 12))
</script>

<template>
  <div class="flag-icon" :class="{ empty: !won, active }">
    <svg viewBox="-30 -30 440 340" xmlns="http://www.w3.org/2000/svg" overflow="visible">
      <!-- Shadow for won flags -->
      <g v-if="won" transform="rotate(8, 0, 261)">
        <g transform="matrix(1.3333333,0,0,-1.3333333,69.617,0.0003)">
          <path :d="FLAG_PATH" fill="#000" />
        </g>
      </g>
      <!-- Flag shape -->
      <g transform="matrix(1.3333333,0,0,-1.3333333,69.617,0.0003)">
        <path :d="FLAG_PATH" :fill="fill" :stroke="strokeAttr" :stroke-width="strokeWidth" />
      </g>
      <!-- Wavy M text for won flags -->
      <template v-if="won">
        <defs>
          <filter :id="filterId" x="-20%" y="-20%" width="140%" height="140%">
            <feTurbulence type="turbulence" baseFrequency="0.015" numOctaves="1" seed="2" result="turb" />
            <feDisplacementMap in="SourceGraphic" in2="turb" scale="12" xChannelSelector="R" yChannelSelector="G" />
          </filter>
        </defs>
        <text
          x="180"
          y="165"
          text-anchor="middle"
          font-size="130"
          font-weight="900"
          fill="#fff"
          :filter="`url(#${filterId})`"
        >
          M
        </text>
      </template>
    </svg>
  </div>
</template>

<style scoped>
.flag-icon {
  width: 100%;
  height: auto;
  aspect-ratio: 26 / 19;
  display: block;
  transform: rotate(-6deg);
  overflow: visible;
}

.flag-icon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.flag-icon.empty svg {
  opacity: 0.3;
}

.flag-icon.active svg {
  filter: drop-shadow(0 0 3px #ffe066);
}
</style>
